module.exports = __webpack_public_path__ + "img/searchEmpty_w.e9629640.svg";